// This file is generated by pnpm icons:generate. Do not edit.

import {SettingsSliderVertical_Stroke2_Corner0_Rounded as CanonicalSettingsSliderVertical_Stroke2_Corner0_Rounded} from './Settings'

/** @deprecated Import SettingsSliderVertical_Stroke2_Corner0_Rounded from `#/components/icons/Settings` instead. */
export const SettingsSliderVertical_Stroke2_Corner0_Rounded =
  CanonicalSettingsSliderVertical_Stroke2_Corner0_Rounded
